module.exports = __webpack_public_path__ + "static/media/img-05.f9fd7444.jpg";